import { render } from "./singleOrder.vue?vue&type=template&id=4775069a&scoped=true"
import script from "./singleOrder.vue?vue&type=script&lang=js"
export * from "./singleOrder.vue?vue&type=script&lang=js"

import "./singleOrder.vue?vue&type=style&index=0&id=4775069a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4775069a"]])

export default __exports__